import {
  AssignConfig, getColorDefault,
  deepAssign, formatLogOption,
  getTooltipDefaultOption,
  getLegendDefaultOption,
} from '@/utils/echarts-option/base'
import { getCssColorVar } from '@/utils/chart-theme-colors'
import { applyEchartsFontToOption, withEchartsTextStyle } from '@/utils/echarts-option/font'

/** grid（横向柱图左侧类目名、纵向柱图数值轴均易超出，containLabel 防裁切） */
export const GRID_RANK_OPTION = {
  top: 6,
  bottom: 60,
  left: 80,
  right: 20,
  containLabel: true,
}

/** legend */
export const LEGEND_RANK_OPTION = {
  bottom: 0,
}

/** yAxis for horizontal bar chart (category axis)（函数形式：颜色运行时读取，主题切换重绘后生效） */
export function getYAxisRankOption () {
  return {
    type: 'category',
    axisTick: {
      alignWithLabel: false,
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: getCssColorVar('--cm-color-border-lighter', 'rgba(221, 221, 221, 0.5)')
      }
    },
    axisLabel: {
      textStyle: withEchartsTextStyle({
        color: getCssColorVar('--cm-color-text-secondary', '#888'),
        lineHeight: 15,
      }),
      padding: [0, 5, 0, 5],
      margin: 10,
    },
  }
}

/** xAxis for horizontal bar chart (value axis) */
export function getXAxisRankOption (config = {} as AssignConfig) {
  const unitString = config.unit ? ` ${config.unit}` : ''
  return {
    type: 'value',
    splitLine: {
      lineStyle: {
        type: 'dotted'
      },
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: getCssColorVar('--cm-color-border-lighter', 'rgba(221, 221, 221, 0.5)'),
      },
    },
    axisLabel: {
      ...withEchartsTextStyle({ color: getCssColorVar('--cm-color-text-secondary', '#888') }),
      formatter: (e) => {
        const value = config.log ? e - 1 : e
        return `${value}${unitString}`
      }
    }
  }
}

/** series */
export const SERIES_RANK_OPTION = {
  type: 'bar',
  barWidth: 20,
}

export function getRankOption (config = {} as AssignConfig) {
  return {
    color: getColorDefault(),
    grid: GRID_RANK_OPTION,
    legend: deepAssign(getLegendDefaultOption() , LEGEND_RANK_OPTION),
    xAxis: getXAxisRankOption(config),
    yAxis: getYAxisRankOption(),
    tooltip: getTooltipDefaultOption(config),
    series: SERIES_RANK_OPTION,
  }
}

export function getAssignRankOption (option: object, config: AssignConfig = {}) {
  option = formatLogOption(option, config)
  return applyEchartsFontToOption(
    deepAssign(getRankOption(config), option) as Record<string, unknown>,
  )
}

